<div class="modal--wrapper">
  <h3>Oops!</h3>
  <div class="typo-body-regular">Sorry, this badge is no longer available.</div>
  <ark-button size="large" (click)="close()">CHOOSE ANOTHER BADGE</ark-button>
</div>
